import React, { useState } from 'react'
import { PortfolioCardCN } from 'components/Card/composed/PortfolioCardCN'
import { CARD_GRID_CLASS } from 'components/Card/cardGrid'
import PortfolioActionSheet from './PortfolioActionSheet'


const PortfoliosCards = ({ portfolios, userId }) => {
	const [sheetOpen, setSheetOpen] = useState(false)
	const [selectedPortfolio, setSelectedPortfolio] = useState(null)

	const handleThreeDotClick = portfolio => {
		setSelectedPortfolio(portfolio)
		setSheetOpen(true)
	}

	return (
		<div>
			<div className={CARD_GRID_CLASS}>
				{portfolios.map((portfolio, index) => {
					const cardLocations = (portfolio.locationImages || [])
						.map(url => ({ imageUrl: url, name: '' }))
					return (
						<div key={portfolio._id || index}>
							<PortfolioCardCN
								name={portfolio.assetName}
								description={portfolio.description}
								portfolioType={portfolio.portfolioType}
								locations={cardLocations}
								locationCount={portfolio.locationCount || 0}
								updatedAt={portfolio.updatedAt}
								linkUrl={`/portfolios/${portfolio._id}`}
								isOwner={portfolio.owner?._id === userId}
								onThreeDotClick={() => handleThreeDotClick(portfolio)}
								ownerImage={portfolio.owner?.image}
								ownerName={portfolio.owner?.name}
								ownerEmail={portfolio.owner?.email}
								ownerCompany={portfolio.owner?.company}
							/>
						</div>
					)
				})}
			</div>

			<PortfolioActionSheet
				portfolio={selectedPortfolio}
				open={sheetOpen}
				onClose={() => setSheetOpen(false)}
				isOwner={selectedPortfolio?.owner?._id === userId}
			/>
		</div>
	)
}

export default PortfoliosCards
